import { useState } from 'react'

import { Button } from '@/components/ui/button'
import { PANEL_WIDTH } from './AgentSurface'
import { AgentTab } from './AgentTabBar'
import { OptionSection } from './OptionSection'
import { ReactAppMock } from './ReactAppMock'

/** Option 4, opened on Ideas — the surface this round is about. */
export function IdeasOptionSection({ shellHeight }: { shellHeight: number }) {
  const [notificationId, setNotificationId] = useState(0)

  return (
    <OptionSection
      title="Option 4: Ideas upsells product capabilities"
      action={
        <Button size="sm" variant="outline" onClick={() => setNotificationId((id) => id + 1)}>
          Send a notification
        </Button>
      }
      panes={[
        {
          label: 'React app',
          width: PANEL_WIDTH,
          content: (
            <ReactAppMock
              height={shellHeight}
              notified={notificationId > 0}
              connect
              blankChat
              initialTab={AgentTab.IDEAS}
            />
          ),
        },
      ]}
    />
  )
}
